// Created by jarongallo at 6/17/21
import React, { useEffect, useState } from 'react';
import UIModal from '../../../../../../components/UI/UIModal';
import CreateInviteCodeModal from '../../../../../../components/modals/CreateInviteCodeModal';
import { PlusIcon } from '../../../../../../assets/icons';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../../components/PL/PLTable/TypeScriptHelpers';
import { INVITE_CODE_TABLE_TYPE } from '../../../../../../components/PL/PLTable/config';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_INVITE_CODES, GET_SALESPERSON_NAME } from './queries';
import { toast } from 'react-toastify';
import PLTable from '../../../../../../components/PL/PLTable/PLTable';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../../redux/selectors/CurrentUserSelectors';
import * as strings from './strings';
import './styles';

export default function IndividualSalespersonInviteCodesTab({ salespersonId }: IndividualSalespersonInviteCodesTabProps) {
	let QUERY_LIMIT = 50;
	const history = useHistory();
	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	let baseVariables = {
		q: {
			formType: 'InviteCode',
			salesmanId: salespersonId
		}
	};
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, INVITE_CODE_TABLE_TYPE, props, baseVariables);

	const [salesperson, setSalesperson] = useState<UserType>();
	const [inviteCodes, setInviteCodes] = useState<InviteCodeType[]>([]);
	const [showCreateInviteCode, setShowCreateInviteCode] = useState<boolean>(false);

	const [getInviteCode, { data: inviteCodeData }] = useLazyQuery(GET_INVITE_CODES, {
		variables
	});

	const [getSalespersonName, { data: salespersonData }] = useLazyQuery(GET_SALESPERSON_NAME, {
		variables: { id: salespersonId }
	});

	useEffect(() => {
		(async () => {
			await getSalespersonName();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (salespersonData) {
				setSalesperson(salespersonData['user']);
				await getInviteCode();
			}
		})();
	}, [salespersonData]);

	useEffect(() => {
		(async () => {
			if (inviteCodeData) {
				const fetchedInviteCodes: InviteCodeType[] = inviteCodeData['forms'];
				setInviteCodes(fetchedInviteCodes);
			}
		})();
	}, [inviteCodeData]);

	if (!salesperson) return null;

	const renderTabComponent = () => {
		return (
			<div className='salespersonTab'>
				<img alt={strings.addInvite} className='salespersonTab__add' src={PlusIcon.white} onClick={() => setShowCreateInviteCode(true)} />
			</div>
		);
	};

	const onCreateSuccess = async () => {
		await getSalespersonName();
		toast.success(strings.createInviteCodeSuccess);
	};

	const renderCreateInviteCodeModal = () => {
		const hideModal = () => {
			setShowCreateInviteCode(false);
		};
		return (
			<UIModal condition={showCreateInviteCode} hideModal={hideModal}>
				<CreateInviteCodeModal salesperson={salesperson} hideModal={hideModal} onCreate={onCreateSuccess} />
			</UIModal>
		);
	};

	return (
		<div className='addSalespersonCode'>
			{renderTabComponent()}
			<PLTable
				emptySetText={`${salesperson.name} ${strings.createInviteCodeEmptySet}`}
				type={INVITE_CODE_TABLE_TYPE}
				limit={50}
				updateTable={getSalespersonName}
				data={inviteCodes}
				onSelect={(inviteCode) => history.push('/invitecode/' + inviteCode.id)}
			/>
			{renderCreateInviteCodeModal()}
		</div>
	);
}
